import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { PillarPerformanceWidgetComponent } from './pillar-performance.widget.component';
import {
    TopPerformanceOpportunity,
    TopPerformanceOpportunityPillarResult,
} from './top-performance-opportunity.widget.model';

@Component({
    selector: 'cmps-widget-top-performance-opportunity',
    templateUrl: './top-performance-opportunity.widget.component.html',
})
export class TopPerformanceOpportunityWidgetComponent
    implements OnInit, OnDestroy
{
    i18n = TranslationKeyMap;
    PillarResult = TopPerformanceOpportunityPillarResult;
    hasPendingData: boolean;
    data: TopPerformanceOpportunity;
    private _modal: NgbModalRef;

    // TODO revise
    private _showGoToDashboardButton: boolean;
    private _kpiIds: number[];
    private _isPerformance: boolean;

    constructor(
        private readonly _modalService: NgbModal,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _service: LegacyWidgetService,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .topPerformanceOpportunity(this._isPerformance)
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
    }

    // TODO revise
    private _evalAttributes(): void {
        this._kpiIds = [];
        this.config.attributes
            .filter((attr) => attr.name)
            .map((attr) => {
                attr.name = attr.name.toLowerCase();
                return attr;
            })
            .forEach((attr) => {
                // if (attr.name === 'displayallpillars')
                // if (attr.name === 'displayvariance')
                // if (attr.name === 'format')
                // if (attr.name === 'includeqtr')
                // if (attr.name === 'includesg')
                // if (attr.name === 'showdateselector')
                if (attr.name === 'showgotodashboardbutton')
                    this._showGoToDashboardButton =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
                // if (attr.name === 'timeframe')
                if (attr.name.startsWith('kpiid')) {
                    if (attr.value == null || attr.value.length === 0) return;
                    this._kpiIds.push(parseInt(attr.value));
                }
                if (attr.name === 'isperformance')
                    this._isPerformance =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
            });
    }

    showDetails(): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            size: 'lg',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component: PillarPerformanceWidgetComponent,
            options: {
                hasDetails: this._showGoToDashboardButton,
                definitionId: this.config.definitionId,
                pillarIds: this._kpiIds,
            },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
